module.exports = __webpack_public_path__ + "static/img/axun22.6d5c4e64.png";